import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './ResaleIndicator.scss';

interface Props {
  isResellable: boolean;
  className?: string;
}

const ResaleIndicator: React.FC<Props> = ({ isResellable, className }) => {
  const { t } = useTranslation();
  if (isResellable) {
    // PM wants to remove this since by default its allowed for resale 99% of the time,
    // so it just creates noise
    return null;
  }
  return (
    <div className={c(s['root'], !isResellable && s['dim'], className)}>
      <ResaleIcon size={IconSize.SMALLER} role="presentation" />
      <span className={s['text']}>
        {t(
          isResellable
            ? 'sidebar.exclusives.resaleIndicator.allowed'
            : 'sidebar.exclusives.resaleIndicator.notAllowed'
        )}
      </span>
    </div>
  );
};

ResaleIndicator.displayName = 'ResaleIndicator';

export default ResaleIndicator;
